// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/css/little_wallet_new.css
 ** module id = 63
 ** module chunks = 0
 **/